import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import get from "lodash/get";
import includes from "lodash/includes";
import { LOGIN, SHIFT_SETTING, LOGOUT } from "../constants/routes";
import { useMediaQuery } from "react-responsive";

const requireAuth = (ChildComponent, roles = [], permission = undefined) => {
  const RequireAuth = (props) => {
    const isMobile = useMediaQuery({ maxWidth: 768 });

    const isLoggedIn = useSelector((state) => get(state, "auth.isLoggedIn"));
    const user = useSelector((state) => get(state, "auth.user"));
    const permissions = useSelector((state) => get(state, "auth.permissions"))
    const navigate = useNavigate();

    useEffect(() => {
      if (!isLoggedIn) {
        navigate(LOGIN); // or '/' if you want to redirect to home
      } else if (isMobile) {
        navigate(SHIFT_SETTING);
      }

      if (roles.length > 0 && !includes(roles, get(user, "role.id"))) {
        navigate(LOGOUT);
      }
      if ((permissions && permission) && !get(permissions, permission)) {
        navigate(LOGOUT)
      }
    }, [isLoggedIn, navigate]);

    return <ChildComponent {...props} />;
  };

  return RequireAuth;
};

export default requireAuth;
